<template>
    <div class="time-selector">
        <p class="label">{{ label }}</p>
        <div class="time-selector-wrapper">
            <button @click="toggleTimeList" class="time-field">
                <p class="selected-time">
                    {{ time }}
                    {{ timeFormat }}
                </p>
                <img
                    :src="getAsset('timepicker-icon.png')"
                    :class="{ 'rotate-arrow': showTime }"
                />
            </button>
            <div v-if="showTime" class="select-time">
                <div class="time-format-container">
                    <button
                        class="time-format"
                        :class="{
                            'selected-time-format': timeFormat === 'AM'
                        }"
                        @click="changeTimeFormat"
                    >
                        AM
                    </button>
                    <button
                        class="time-format"
                        :class="{
                            'selected-time-format': timeFormat === 'PM'
                        }"
                        @click="changeTimeFormat"
                    >
                        PM
                    </button>
                </div>
                <div class="divider"></div>
                <div class="time-count">
                    <button
                        @click="setTime(time)"
                        class="time"
                        v-for="(time, index) in timeList"
                        :key="index"
                    >
                        {{ time }} <span class="time-format">{{ timeFormat }}</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { useTimeSelector } from '@/composables/ui/useTimeSelectorExperimental'

    export default {
        name: 'TimeSelector',
        props: {
            label: {
                required: true,
                type: String
            },
            inputTime: {
                required: false,
                type: String,
                default: '12:00',
                validator: (val) => {
                    const hours = parseInt(val.split(':')[0])
                    const minutes = parseInt(val.split(':')[1])

                    return hours >= 1 && hours <= 12 && minutes >= 0 && minutes < 60
                }
            },
            inputFormat: {
                required: false,
                type: String,
                default: 'AM',
                validator: (val) => ['AM', 'PM'].includes(val)
            }
        },
        emits: ['update:inputTime', 'update:inputFormat'],
        setup(props, context) {
            const {
                timeList,
                time,
                timeFormat,
                showTime,
                changeTimeFormat,
                setTime,
                toggleTimeList
            } = useTimeSelector(props, context)

            return {
                timeList,
                time,
                timeFormat,
                showTime,
                changeTimeFormat,
                setTime,
                toggleTimeList
            }
        },
        methods: {
            getAsset(path, dir = 'images') {
                return `/${dir}/${path}`
            }
        }
    }
</script>
<style lang="scss" scoped>
    p {
        margin-bottom: 0px;
    }
    button {
        border: none;
        background: none;
    }
    .time-selector {
        display: flex;
        flex-direction: column;
        width: 146px;
        align-items: flex-start;
        justify-content: center;
        gap: 6px;

        .label {
            color: #8b8b8b;
            font-family: 'Instrument Sans';
            font-size: 12px;
            font-style: normal;
            font-weight: 650;
            line-height: 135%;
            letter-spacing: 0.12px;
        }
        .time-selector-wrapper {
            position: relative;
            display: flex;
            padding: 12px 12px 13px 16px;
            align-items: center;
            gap: 12px;
            align-self: stretch;
            border-radius: 12px;
            border: 1px solid #8b8b8b;
            background: #262626;
            color: #646464;
            font-family: 'Instrument Sans';
            font-size: 18px;
            font-style: normal;
            font-weight: 650;
            line-height: 120%;
            height: 47px;

            .time-field {
                display: flex;
                align-items: center;
                padding: 0px;
                gap: 12px;

                .selected-time {
                    color: #dedede;
                    font-family: 'Instrument Sans';
                    font-size: 18px;
                    font-style: normal;
                    font-weight: 650;
                    line-height: 120%;
                    margin: 0;
                    text-wrap: nowrap;
                }
                .rotate-arrow {
                    transform: rotate(180deg);
                }
            }
            .select-time::-webkit-scrollbar {
                display: none;
            }
            .select-time {
                z-index: 1;
                position: absolute;
                padding: 8px 8px 12px 8px;
                display: flex;
                flex-direction: column;
                gap: 8px;
                border-radius: 12px;
                background: #333;
                box-shadow: 0 6px 12px -4px rgba(0, 0, 0, 0.5);
                top: 50px;
                left: 0;
                max-height: 200px;
                min-width: 150px;

                .time-format-container {
                    display: flex;
                    justify-content: center;
                    align-items: flex-start;
                    gap: 8px;
                    align-self: stretch;

                    .time-format {
                        display: flex;
                        padding: 4px 8px;
                        justify-content: center;
                        align-items: center;
                        flex: 1 0 0;
                        border-radius: 6px;
                        margin: 0;
                        font-family: 'Instrument Sans';
                        font-size: 18px;
                        font-style: normal;
                        font-weight: 650;
                        line-height: 120%;
                        color: #8b8b8b;
                    }
                    .selected-time-format {
                        background: #cdeb09;
                        color: #121212;
                    }
                }
                .divider {
                    width: 100%;
                    height: 1px;
                    background: #8b8b8b;
                }
                .time-count::-webkit-scrollbar {
                    width: 8px;
                }
                .time-count::-webkit-scrollbar-track {
                    background-color: none;
                }
                .time-count::-webkit-scrollbar-thumb {
                    max-height: 64px;
                    border-radius: 8px;
                    background: #8b8b8b;
                }
                .time-count {
                    display: flex;
                    flex-direction: column;
                    overflow-y: scroll;
                    gap: 8px;

                    .time {
                        color: #dedede;
                        font-family: 'Instrument Sans';
                        font-size: 18px;
                        font-style: normal;
                        font-weight: 650;
                        line-height: 120%;
                        margin: 0;

                        .time-format {
                            color: #8b8b8b;
                            font-family: 'Instrument Sans';
                            font-size: 16px;
                            font-style: normal;
                            font-weight: 550;
                            line-height: 125%;
                        }
                    }
                }
            }
        }
    }
</style>
